module.exports = __webpack_public_path__ + "img/5_001.e78c30be.webp";